module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-desktop-en.ea1bccae.webp";